module.exports = __webpack_public_path__ + "img/bs.524a1ab5.svg";